import { Select } from 'antd'
import { observer } from 'mobx-react-lite'

import { classNames } from '@/Ship/Helpers/classNames'
import { ALL_EMPLOYEES, dashboardManager } from '@/Ship/Stores/DashboardManager'

import styles from './Overview/Overview.module.css'

export const EMPLOYEE_FILTER_LABEL = 'Фільтр по співробітнику'

/** Верхня опція й значення за замовчуванням — уся компанія. */
export const ALL_EMPLOYEES_LABEL = 'Усі співробітники'

/**
 * «Фільтр по співробітнику» (`SPEC-015` §5.2) — лише за правом
 * `dashboard_others` з `/auth/permissions` (A, SA), а не за сирими ролями на
 * фронті, як у легасі.
 *
 *  - за замовчуванням і після очищення — «Усі співробітники» (уся компанія);
 *    вибір себе — саме свої цифри; поле завжди показує, чиї цифри на екрані;
 *  - у списку — лише активні співробітники (бек `Setting.User`); пошук за ПІБ;
 *  - вибір живе в `DashboardManager` і спільний для всієї сторінки: плитки
 *    справ, віджети перевезень і огляд;
 *  - стоїть у шапці сторінки поруч із періодом, без окремого блоку.
 */
export const DashboardEmployeeFilter = observer(() => {
    const manager = dashboardManager

    if (!manager.canFilterByEmployee) return null

    return (
        <Select
            className={classNames(styles['employee'])}
            aria-label={EMPLOYEE_FILTER_LABEL}
            title={EMPLOYEE_FILTER_LABEL}
            placeholder={EMPLOYEE_FILTER_LABEL}
            data-testid="dashboard-employee-filter"
            allowClear={manager.selectedUuid !== null}
            value={manager.employeeValue}
            options={[
                { value: ALL_EMPLOYEES, label: ALL_EMPLOYEES_LABEL },
                ...manager.employeeOptions.map((item) => ({ value: item.uuid, label: item.fullName || item.uuid })),
            ]}
            loading={manager.isEmployeesLoading}
            showSearch={{ filterOption: false, onSearch: (query: string) => void manager.searchEmployees(query) }}
            onOpenChange={(open: boolean) => {
                if (open) void manager.searchEmployees('')
            }}
            onChange={(uuid: string | undefined) => manager.selectEmployee(uuid ?? null)}
            notFoundContent={manager.isEmployeesLoading ? null : 'Нікого не знайдено'}
        />
    )
})
